export enum MAX_WIDTH {
  XL = "8xl",
  XS = "xl",
}
